import { effects } from 'redux-saga'
import { makeSelectIpns } from 'internal-components/src/redux/modules/client'

import { updateFilter } from '../../modules/signupEdit/actions'

export default function* begin() {
  const selector = yield effects.call(makeSelectIpns)
  const state = yield effects.select()

  const ipns = yield effects.call(selector, state)

  yield effects.put.resolve(updateFilter('hasIpn', ipns.size > 0))
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/ipn.js